import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * BootScreen — Suspense fallback for the lazy app-core / admin-core chunks
 * (CEL-1086). Visually identical to the anti-flash boot splash in
 * public/index.html (same background + accent colors, same 38px spinner
 * geometry), so a logged-in cold load reads as ONE continuous loading state:
 * splash (pre-React) → BootScreen (chunk downloading) → app.
 */
const BootScreen = () => {
  const { isDarkMode } = useTheme();
  const bg = isDarkMode ? '#0a0b0d' : '#ffffff';
  const accent = isDarkMode ? '#7dc3c3' : '#2e7e7e';
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 2147483646, background: bg }}>
      <style>{'@keyframes cc-boot-spin{to{transform:rotate(360deg)}}'}</style>
      <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          width: 38,
          height: 38,
          margin: '-19px 0 0 -19px',
          borderRadius: '50%',
          boxSizing: 'border-box',
          border: `3px solid ${accent}33`,
          borderTopColor: accent,
          animation: 'cc-boot-spin .8s linear infinite',
        }}
      />
    </div>
  );
};

export default BootScreen;
